module.exports = __webpack_public_path__ + "img/Group 1840@2x(2).3eae67b7.png";